import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Typography,
  Button,
  useTheme,
  alpha,
} from '@mui/material';

const Layout: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      width: '100%',
      minWidth: 'max-content',
    }}>
      <Box
        component="main"
        sx={{
          flex: 1,
          backgroundColor: '#ffffff',
          width: '100%',
          minWidth: 'max-content',
          overflowX: 'auto',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
